<div [formGroup]="innerForm"
    class="flex flex-row gap-0 w-full focus-within:ring-2 focus-within:border-secondary-400 rounded-lg items-center transition-all duration-200 overflow-visible bg-transparent">

    <div class="flex-grow relative">
        <input formControlName="book" type="text" placeholder="Book e.g Psalms (Tab to autocomplete)"
            (input)="onBookInput()" (keydown)="handleBookKeyDown($event)" (blur)="hideDropdown()"
            class="w-full px-3 py-2 capitalize rounded-l border-l-2 border-y-2 border-gray-300 focus:ring-0 text-sm bg-transparent outline-none placeholder:text-gray-400">

        @if (showDropdown && filteredBooks.length > 0) {
        <ul
            class="absolute z-50 left-0 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-xl max-h-60 overflow-y-auto">
            @for (book of filteredBooks; track book; let i = $index) {
            <li (mousedown)="selectBook(book)" [class.bg-blue-100]="i === activeIndex"
                [class.text-blue-900]="i === activeIndex"
                class="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 text-gray-900 transition-colors">
                {{ book | titlecase }}
            </li>
            }
        </ul>
        }
    </div>

    <div class="flex-1">
        <input formControlName="chapter" type="number" placeholder="Chapter"
            class="w-full px-2 py-2 border-y-2 focus:ring-0 border-gray-300 text-sm bg-transparent outline-none placeholder:text-gray-400 text-center [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none">
    </div>

    <div class="flex-1">
        <input formControlName="verse" type="number" placeholder="Verse"
            class="w-full px-2 py-2 rounded-r border-r-2 border-y-2 focus:ring-0 border-gray-300 text-sm bg-transparent outline-none placeholder:text-gray-400 text-center [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none">
    </div>
</div>